/* src/app/features/programas-permitidos-por-cestas/habilitacao-programa/habilitacao-programa.component.scss */
.width-80 {
  width: 80%;
}
.width-95 {
  width: 95%;
}
.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-disabled {
  cursor: default;
}
table ng-select {
  width: 100%;
  display: block;
}
.table-layout-fixed {
  table-layout: fixed;
}
/*# sourceMappingURL=habilitacao-programa.component.css.map */
